<template>
  <div class="error-page">
    <div class="overlay" />
    <div class="posR tAc">
      <h1 v-if="error.statusCode">{{ `Error ${error.statusCode}` }}</h1>
      <h2 v-if="error.errorTitle">{{ error.errorTitle }}</h2>
      <h2 v-if="error.errorTitleI18N">{{ $t(error.errorTitleI18N) }}</h2>
      <p v-if="error.subTitle">{{ $t(error.subTitle) }}</p>
      <a v-if="!error.goBackButton"
         href="/"
         class="btn topaz">{{ $t('error.irALaHome') }}</a>
      <b-button v-else
                class="topaz mT25"
                @click="goBack">{{ $t('error.volver') }}</b-button>
      <no-ssr>
        <loader v-show="true"
                :full="true" />
      </no-ssr>
    </div>
  </div>
</template>
<script>
import Loader from '@/components/loader/Loader.vue'

export default {
  components: {
    Loader
  },
  data: () => ({
    error: {
      statusCode: 404,
      errorTitleI18N: 'error.tiempoDeReservaAgotado',
      subTitle: 'error.seleccionalasDeNuevo',
      goBackButton: true
    }
  }),
  layout: 'simple',
  mounted() {
    var loader = document.getElementById('loader-box')
    if (loader) {
      loader.classList.add('hide-loader')
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: process.env.VUE_APP_INITIAL_URL
      })
    }
  }
}
</script>
